import { render, staticRenderFns } from "./IpsHistory.vue?vue&type=template&id=24469596&scoped=true&"
import script from "./IpsHistory.vue?vue&type=script&lang=js&"
export * from "./IpsHistory.vue?vue&type=script&lang=js&"
import style0 from "./IpsHistory.vue?vue&type=style&index=0&id=24469596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24469596",
  null
  
)

export default component.exports